module.exports = __webpack_public_path__ + "media/images/nightlife-planning-69be5ab46e458babb49a8b1880bd3970.svg";